import AuthService from "../services/auth.service";

const user = localStorage.getItem("user_free");
const initialState = user ? { loggedIn: true } : { loggedIn: false };

export const auth = {
  namespaced: true,
  state: initialState,
  actions: {
    async login({ commit }, user) {
      try {
        const userData = await AuthService.login(user); // Call the auth service
        commit("SET_USER", userData); // Commit the user data to the store
        commit("isLoggedIn", true);
        return userData; // Return the user data to the caller
      } catch (error) {
        // console.error('Login failed:', error);
        commit("isLoggedIn", false);
        throw error; // Propagate the error
      }
    },
    async logout({ commit }) {
      try {
        await AuthService.logout();
        commit("SET_USER", null); // Clear user data
        localStorage.removeItem("user_free"); // Remove token from localStorage
        localStorage.removeItem("user_data"); // Remove user data from localStorage
        commit("isLoggedIn", false);
      } catch (error) {
        commit("isLoggedIn", true);
        throw error;
      }
    },
  },
  mutations: {
    isLoggedIn(state, loggedIn) {
      state.loggedIn = loggedIn;
    },
    SET_USER(state, user) {
      state.user = user;
      state.loggedIn = !!user; // Set loggedIn based on whether user exists
    },
  },
  getters: {
    isLoggedIn(state) {
      return state.loggedIn;
    },
  },
};
